import { Card } from "antd";

type Props = {
  message: string;
};

const CardEmptyState: React.FC<Props> = ({ message }) => {
  return (
    <Card bordered={false}>
      <p className="text-light-grey">{message}</p>
    </Card>
  );
};

export default CardEmptyState;
